/* eslint-disable no-sequences */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { eventTypes } from "./event-type-data";
import p1 from "../../assets2/icons/venuPre1.svg";
import p2 from "../../assets2/icons/venuPre2.svg";
import p3 from "../../assets2/icons/catering/Catering.svg";
import p4 from "../../assets2/icons/catering/external.svg";
import p5 from "../../assets2/icons/catering/nAllowed.png";
import p6 from "../../assets2/icons/catering/vector.svg";
import Tooltip from "./Tooltip";

const OverviewSection = ({ data, locationDetails }) => {
	// Overview details pulled dynamically from data
	const getIconForEventType = (title) => {
		const eventType = eventTypes.find((type) => type.title === title);
		return eventType ? eventType.icon : null; // Return null if no match is found
	};
	const overviewDetails = [
		{
			icon: (() => {
				const venueHire = data?.additionalDetails?.venueHire;

				const isPrivateSelected = Array.isArray(venueHire)
					? venueHire.includes("Exclusive")
					: venueHire === "Private";

				if (isPrivateSelected) {
					return (
						<img
							src={getIconForEventType("Exclusive")}
							className="w-8 h-8"
							alt="Private"
						/>
					);
				}

				// If not selected, return faded + strikethrough
				return (
					<div style={{ position: "relative", display: "inline-block" }}>
						<img
							src={getIconForEventType("Exclusive")}
							className="w-8 h-8 opacity-30"
							alt="Not Private"
						/>
						<div
							style={{
								position: "absolute",
								top: "-25px",
								left: "-25px",
								width: "150%",
								height: "150%",
								transform: "rotate(140deg)",
								borderTop: "2.5px solid #C2C2C2",
							}}
						></div>
					</div>
				);
			})(),
			label: "Private space",
			value:
				typeof data?.additionalDetails?.venueHire === "string"
					? data?.additionalDetails?.venueHire !== "Private"
						? "Private "
						: "Private"
					: data.additionalDetails?.venueHire?.includes("Exclusive")
					? "Private"
					: "Private ",
		},
		{
			icon: <img src={p2} className="w-8 h-8" alt="standing" />,
			label: "Sitting",
			value: `Upto ${data?.capacity?.sitting || "N/A"} Sitting`,
		},
		{
			icon: <img src={p1} className="w-8 h-8" alt="standing" />,
			label: "Standing",
			value: `Upto ${data?.capacity?.standing || "N/A"} Standing`,
		},
		{
			icon: <img src={p3} className="w-8 h-8" alt="Offers catering" />,
			label: "Offers catering",
			value: "Offers catering",
		},
		{
			icon:
				data?.cateringAndDrinks?.externalCatering === false ? (
					<div className="h-[38px] w-auto relative">
						<img
							src={p5}
							className=" w-full h-full bg-cover"
							alt="Does not offer catering"
						/>

						<img
							src={p6}
							className="w-ful h-full absolute top-0 left-0"
							alt="Does not offer catering"
						/>
					</div>
				) : (
					<img src={p4} className="w-8 h-8" alt="Outside catering" />
				),
			label: "Outside catering",
			value: "Outside catering allowed",
		},
	];

	const filteredOverviewDetails = overviewDetails.filter(
		(detail) => detail.value
	);

	console.log("Filtered Overview Details:", filteredOverviewDetails);
	return (
		<div className="w-full mx-auto">
			<h3 className="text-2xl font-bold py-4">Overview</h3>

			<div className="md:grid md:grid-cols-5 grid-cols-2 justify-between gap-4 mb-4 flex md:flex-none overflow-x-auto">
				{filteredOverviewDetails?.map((detail, index) => (
					<div
						key={index}
						className="min-h-[150px] md:w-[85%] w-[163px] flex flex-col gap-2 gap-y-3 text-center text-black items-center bg-[#F7F7F7] p-4 rounded-lg shadow-md flex-shrink-0"
					>
						<div>{detail.icon}</div>
						<div>
							{detail.value === "Outside catering allowed" ? (
								<p
									className={`text-[14px] lg:text-[20px] md:text-center text-left ${
										data?.cateringAndDrinks?.externalCatering
											? "text-black"
											: "text-[#717171]"
									}`}
								>
									Outside Catering
								</p>
							) : (
								<p
									className={`text-[14px] lg:text-[20px] md:text-center text-left ${
										detail.value === "Private "
											? "text-[#717171]"
											: "text-black"
									}`}
								>
									{detail.value?.trim() === "Private"
										? "Exclusive"
										: detail.value}
								</p>
							)}
							{/* <p
                className={`text-[14px] lg:text-[20px] md:text-center text-left ${
                  detail.value == "Outside catering allowed"
                    ? "text-black"
                    : "text-[#717171]"
                }`}
              >
                {detail.value == "Outside catering allowed"
                  ? "Outside catering"
                  : detail?.value}
              </p> */}
						</div>
						{detail?.label === "Private space" && (
							<div className="md:absolute hidden top-2 right-6">
								{detail?.value ? (
									<Tooltip
										text={
											detail?.value === "Private"
												? "Private hire is a space within venue that is exclusively reserved for your event"
												: detail?.value === "Whole venue"
												? "The entire venue is exclusively available for your event."
												: detail?.value === "Semi-private"
												? "Semi-private hire involves booking a section of a venue that is partially secluded or separated, allowing for some privacy while other events or guests may also be present."
												: detail?.value === "Shared space"
												? "A non-exclusive, common area with open access for everyone."
												: ""
										}
									/>
								) : null}
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default OverviewSection;
